import {
  APPROVEORREJECTMANUALUPGRADEKYC_SUCCESS,
  APPROVEORREJECTMANUALUPGRADEKYC_FAILED,
  RESET_APPROVEORREJECTMANUALUPGRADEKYC,
  LOADING_APPROVEORREJECTMANUALUPGRADEKYC,
  NETWORK_ERROR_APPROVEORREJECTMANUALUPGRADEKYC,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_APPROVEORREJECTMANUALUPGRADEKYC:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case APPROVEORREJECTMANUALUPGRADEKYC_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case APPROVEORREJECTMANUALUPGRADEKYC_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_APPROVEORREJECTMANUALUPGRADEKYC:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_APPROVEORREJECTMANUALUPGRADEKYC:
      return (state = initialState);
    default:
      return state;
  }
};
